import React, { useState } from "react";
import { EMAIL, PHONE_NL } from "../site/constants";
import ContentPage from "../components/ContentPage";

const FAQS = [
  {
    q: "Vanuit welke landen kan ik bestellen?",
    a: "Je kunt vanuit Nederland en andere Europese landen een bestelling plaatsen. De beschikbare betaalmethoden kunnen per land verschillen.",
  },
  {
    q: "Kan ik bestellen wanneer ik buiten Europa woon?",
    a: "Vul tijdens het afrekenen je land in om te controleren of bestellen en betalen vanuit jouw locatie mogelijk is.",
  },
  {
    q: "Waar bezorgen jullie in Suriname?",
    a: "Wij bezorgen lokaal in Suriname. Tijdens het bestellen kun je controleren of het adres binnen ons bezorggebied valt.",
  },
  {
    q: "Hoelang duurt de bezorging?",
    a: "De bezorgtijd is afhankelijk van het product, het bezorggebied en het moment waarop je bestelt. De verwachte bezorgperiode wordt tijdens het bestellen weergegeven.",
  },
  {
    q: "Hoe weet ik dat mijn bestelling is bezorgd?",
    a: "Je ontvangt een update zodra de bestelling is verwerkt en bezorgd. Waar mogelijk bieden wij aanvullende bezorgbevestiging.",
  },
  {
    q: "Kan de ontvanger zelf producten kiezen?",
    a: "Ja. De ontvanger kan een verlanglijst samenstellen en deze met iemand in Europa delen voor betaling.",
  },
  {
    q: "Kan ik een persoonlijke boodschap toevoegen?",
    a: "Ja. Bij geschikte cadeaus en pakketten kun je tijdens het bestellen een persoonlijke boodschap toevoegen.",
  },
  {
    q: "Kan ik voor meerdere mensen bestellen?",
    a: "Ja. Je kunt verschillende ontvangers en bezorgadressen aan je account toevoegen.",
  },
  {
    q: "Welke valuta gebruiken jullie?",
    a: "De beschikbare valuta worden in de app weergegeven. Prijzen en betaalmogelijkheden kunnen afhankelijk zijn van het land van waaruit je bestelt.",
  },
  {
    q: "Kan ik mijn bestelling wijzigen?",
    a: "Neem zo snel mogelijk contact op met onze klantenservice. Zodra een bestelling wordt verwerkt of bezorgd, is wijzigen mogelijk niet meer mogelijk.",
  },
  {
    q: "Kan ik een zakelijke bestelling plaatsen?",
    a: "Ja. Neem contact met ons op voor grotere aantallen, personeelsgeschenken, donaties of andere zakelijke bestellingen.",
  },
  {
    q: "Hoe kan ik contact opnemen?",
    a: `Je bereikt ons via WhatsApp (${PHONE_NL}) of e-mail (${EMAIL}).`,
  },
];

export default function FaqPage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <ContentPage
      title="Veelgestelde vragen"
      lead="Antwoorden op de meest gestelde vragen over bestellen vanuit Europa en bezorging in Suriname."
      ctaLabel="Start met bestellen"
      secondaryLabel="Neem contact op"
      secondaryTo="/contact"
    >
      <div className="lp-faq">
        {FAQS.map((item, i) => {
          const open = openFaq === i;
          return (
            <div
              key={item.q}
              className={`lp-faq-item ${open ? "is-open" : ""}`}
            >
              <button
                type="button"
                className="lp-faq-q"
                onClick={() => setOpenFaq(open ? -1 : i)}
                aria-expanded={open}
              >
                <span>{item.q}</span>
                <span className="lp-faq-icon">{open ? "−" : "+"}</span>
              </button>
              {open && <p className="lp-faq-a">{item.a}</p>}
            </div>
          );
        })}
      </div>
    </ContentPage>
  );
}
